<template>
    <div v-if="invoice">
        <InvoiceCharge v-for="(fee, index) in invoice.fees" :key="index" :description="fee.description" :heading="fee.heading" :price="fee.price"/>
        <hr style="height:2px;" class="bn mv3 mid-gray bg-mid-gray"/>
        <InvoiceCharge heading="Subtotal" :price="subtotal"/>
        <hr style="height:2px;" class="bn mv3 mid-gray bg-mid-gray"/>
        <InvoiceCharge v-for="(fee, index) in invoice.refundableFees" :key="'refundable' + index" :description="fee.description" :heading="fee.heading" :price="fee.price"/>        
        <hr style="height:3px;" class="bn mv3 black bg-black"/>
        <div class="cf">
            <span class="fr">Total: <h5 class="dib">{{total | toCurrency}}</h5></span>
        </div>
    </div>    
</template>

<script>
import InvoiceCharge from '@/components/rent/shared/chargeSummary/InvoiceCharge.vue';

export default {
    components: {
        InvoiceCharge
    },
    props: {
        invoice: {
            type: Object
        }
    },
    computed: {
        subtotal() {
            return this.invoice.fees.reduce(
                (total, fee) => total + fee.price,
                0
            );
        },
        total() {
            return (
                this.invoice.refundableFees.reduce(
                    (total, fee) => total + fee.price,
                    0
                ) + this.subtotal
            );
        }
    }
};
</script>
